import React, { useState, useEffect } from 'react';
import { reportsAPI } from '../lib/api';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Map as MapIcon, Users, Building2, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const TerritoriesPage = () => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        reportsAPI.territories()
            .then((res) => setRows(res.data || []))
            .catch(() => toast.error('Errore nel caricamento dei territori'))
            .finally(() => setLoading(false));
    }, []);

    const totalCountries = rows.reduce((s, r) => s + (r.countries_count || 0), 0);
    const totalClients = rows.reduce((s, r) => s + (r.clients_count || 0), 0);

    return (
        <div className="space-y-6" data-testid="territories-page">
            <div>
                <h1 className="font-heading text-3xl uppercase tracking-tight">Riepilogo Territori</h1>
                <p className="text-muted-foreground">
                    Nazioni di competenza e clienti per ogni commerciale
                </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <Card><CardContent className="pt-6 flex items-center gap-3">
                    <div className="w-11 h-11 rounded-sm bg-secondary/10 flex items-center justify-center text-secondary"><Users size={22} /></div>
                    <div><p className="text-2xl font-heading">{rows.length}</p><p className="text-xs text-muted-foreground uppercase tracking-wider">Commerciali</p></div>
                </CardContent></Card>
                <Card><CardContent className="pt-6 flex items-center gap-3">
                    <div className="w-11 h-11 rounded-sm bg-secondary/10 flex items-center justify-center text-secondary"><MapIcon size={22} /></div>
                    <div><p className="text-2xl font-heading">{totalCountries}</p><p className="text-xs text-muted-foreground uppercase tracking-wider">Nazioni assegnate</p></div>
                </CardContent></Card>
                <Card><CardContent className="pt-6 flex items-center gap-3">
                    <div className="w-11 h-11 rounded-sm bg-secondary/10 flex items-center justify-center text-secondary"><Building2 size={22} /></div>
                    <div><p className="text-2xl font-heading">{totalClients}</p><p className="text-xs text-muted-foreground uppercase tracking-wider">Clienti totali</p></div>
                </CardContent></Card>
            </div>

            <Card>
                <CardContent className="p-0">
                    <div className="overflow-x-auto">
                        <table className="w-full data-table table-zebra">
                            <thead>
                                <tr className="border-b bg-muted/30">
                                    <th className="text-left py-4 px-4">Commerciale</th>
                                    <th className="text-center py-4 px-4 w-32">N. Nazioni</th>
                                    <th className="text-center py-4 px-4 w-28">Clienti</th>
                                    <th className="text-left py-4 px-4">Nazioni di competenza</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr><td colSpan={4} className="text-center py-10"><Loader2 className="inline animate-spin" /></td></tr>
                                ) : rows.length === 0 ? (
                                    <tr><td colSpan={4} className="text-center py-8 text-muted-foreground">Nessun commerciale</td></tr>
                                ) : (
                                    rows.map((r) => (
                                        <tr key={r.id} className="border-b hover:bg-muted/30" data-testid={`territory-row-${r.id}`}>
                                            <td className="py-4 px-4 font-medium">{r.name}</td>
                                            <td className="py-4 px-4 text-center font-mono">{r.countries_count}</td>
                                            <td className="py-4 px-4 text-center font-mono">{r.clients_count}</td>
                                            <td className="py-4 px-4">
                                                <div className="flex flex-wrap gap-1.5">
                                                    {(r.countries || []).length === 0 ? (
                                                        <span className="text-sm text-muted-foreground">—</span>
                                                    ) : (
                                                        r.countries.map((c) => (
                                                            <Badge key={c} variant="secondary" className="text-xs">{c}</Badge>
                                                        ))
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default TerritoriesPage;
